<cac-dialog-layout
  [title]="data.area ? 'Edit Area' : 'Add New Area'"
  subtitle="Enter the required data and save"
  (onSubmit)="onSubmit($event)"
>
  <div class="p-6">
    <cac-form-builder [options]="form"></cac-form-builder>
  </div>
</cac-dialog-layout>
